module.exports = __webpack_public_path__ + "img/CBCL.582cb30a.png";